module.exports = __webpack_public_path__ + "img/emptystate-search.5e0cbf6e.svg";